module.exports = __webpack_public_path__ + "img/Florida-poly-logo.89d28c0f.png";